import React from 'react';
import { useIntl } from 'umi';
import MultipleSelector, { renderImgText } from './MultipleSelector';
import AnnieIcon from '@/pages/intelligence/assets/svg/dataSource/appnnie.svg';
import Sensortower from '@/pages/intelligence/assets/svg/dataSource/sensor-tower.svg';
import MScienceIcon from '@/pages/intelligence/assets/svg/dataSource/mscience.svg';
import NPD from '@/pages/intelligence/assets/svg/dataSource/npd.svg';
import type { IBaseProps } from '@/pages/intelligence/types/common';

const SOURCES_ICONS: {
  [key: string]: string;
} = {
  appannie: AnnieIcon,
  mscience: MScienceIcon,
  sensortower: Sensortower,
  npd: NPD,
};

interface IISourceMetricSelectorOption {
  text?: string;
  label: string;
  source?: string;
  value: string;
}

interface ISourceMetricSelectorProps extends IBaseProps {
  className?: string;
  options: IISourceMetricSelectorOption[];
  value: string[];
  onConfirm: (payload: string[]) => void;
}

export default function SourceMetricSelector(props: ISourceMetricSelectorProps) {
  const { formatMessage } = useIntl();

  const { className, options: optionsOuter, value: valueOuter, onConfirm } = props;

  const options = (() => {
    if (!Array.isArray(optionsOuter)) return [];
    return optionsOuter.map((item) => {
      const { label, source, value } = item ?? {};
      const icon = source ? SOURCES_ICONS[source] : '';
      return {
        text: renderImgText(label, icon),
        value: value ?? '',
      };
    });
  })();

  const value = Array.isArray(valueOuter) ? valueOuter : [];

  return (
    <MultipleSelector
      className={className}
      hasAllCheck={false}
      buttonName={formatMessage({ id: 'dbi_label_metrics' })}
      options={options}
      value={value}
      onChange={onConfirm}
    />
  );
}
